import React from 'react'
import Popup from './Popup1';
import Contracts_popup from './Contracts_popup';
import "../styles/scope.css";
import { useState, useRef, useEffect } from "react";
import DatePicker from "./DatePicker"
import ReactPaginate from "react-paginate";
import Header from './Header';
import { useNavigate } from 'react-router-dom';
import Contracts_header from './Header/Contracts_header';
import axios from 'axios';
import Vector from "../assets/svg/editIcon.svg";
import Delete from "../assets/svg/DeleteIcon.svg";
import filterOpenCloseIcon from "../assets/svg/filterOpenCloseIcon.svg";
import { ToastContainer, toast } from "react-toastify"
import axiosInstance from '../axiosInstance';
import { usePermissions } from '../hooks/PermissionContext';
import { useModule } from '../hooks/ModuleContext';
import PermissionWrapper from '../hooks/PermissionWrapper';
import AdditionalPermissionWrapper from '../hooks/AdditionalPermissionWrapper';
import ConfirmDialog from '../ConfirmDialog/ConfirmDialog';
import CommonFooter from '../CommonFooter/CommonFooter';
import ContractFilter from './ContractFilter';
import CommonPagination from '../CommonPagination/CommonPagination';
import ContractManualTriggerPopup from './Contract/ContractManualTriggerPopup';


const Contracts = () => {

  const { activeModuleId } = useModule();
  const { getModulePermission } = usePermissions();
  const permission = getModulePermission(activeModuleId);

  const [searchTerm, setSearchTerm] = useState('');
  const [tableData, setTableData] = useState([]);
  const [error, setError] = useState(null);
  const [limit, setLimit] = useState(5);
  const [currentPage, setCurrentPage] = useState(0);
  const [skip, setSkip] = useState(0);
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const popupRef = useRef(null);
  const [editData, setEditData] = useState(null);
  const [contractData, setContracts] = useState([]);
  const [selectedContractId, setSelectedContractId] = useState(null);
  const [sortBy, setSortBy] = useState("dateCreated");
  const [showConfirm, setShowConfirm] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [confirmConvertOpen, setConfirmConvertOpen] = useState(false);
  const [showFilter, setShowFilter] = useState(true);
  const [filters, setFilters] = useState({
    contractCode: [],
    project: [],
    plantCode: [],
    fromDate: null,
    toDate: null,
    profitCenter: [],
    city: [],
    state: [],
    zone: []
  });

  const [manualTriggerOpen, setManualTriggerOpen] = useState(false);
  const [manualTriggerData, setManualTriggerData] = useState([]);
  const navigate = useNavigate();

  const fetchContracts = async (term = '', appliedFilters = filters) => {
    try {
      const response = await axiosInstance.post(`/contract/list`,
        {
          limit,
          skip,
          sortBy,
          search: term || '',
          filter: {
            contract_code: appliedFilters.contractCode || '',
            project: appliedFilters.project || '',
            plant_code: appliedFilters.plantCode,
            from_date: appliedFilters.fromDate
              ? new Date(appliedFilters.fromDate).toISOString().split("T")[0]
              : '',
            to_date: appliedFilters.toDate
              ? new Date(appliedFilters.toDate).toISOString().split("T")[0]
              : '',
            profit_centre: appliedFilters.profitCenter || '',
            city: appliedFilters.city || '',
            state: appliedFilters.state || '',
            zones: appliedFilters.zone || '',
          }
        });

      if (response.data && Array.isArray(response.data.contract)) {
        setTableData(response.data.contract);
        setContracts(response.data.contract);
        const newTotal = response.data.totalCount || 0;
        setTotal(newTotal);
        setTotalPages(Math.ceil(newTotal / limit));
      } else {
        setTableData([]);
      }
    } catch (error) {
      console.error("Fetch error:", error);
      toast.error("Failed to fetch contracts");
    }
  };

  useEffect(() => {
    fetchContracts(searchTerm);
  }, [skip, limit]);


  const handleEditClick = async (contract_id) => {
    try {
      const response = await axiosInstance.get(
        `/contract/edit/${contract_id}`
      );

      if (response.data && response.data.charges) {
        navigate(`/contracts_popup`, { state: { charges: response.data.charges } });
      } else {
        throw new Error("Project data not found");
      }
    } catch (error) {
      setError(error.message);
      console.error("Error fetching project details:", error);
    }
  };


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        closePopup();
      }
    };
    if (isPopupOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isPopupOpen]);


  const handlePageClick = ({ selected }) => {
    const newSkip = selected * limit;
    setCurrentPage(selected);
    setSkip(newSkip);
    setSelectedRows([]);
  };

  const handleLimitChange = (e) => {
    const newLimit = Number(e.target.value);
    setLimit(newLimit);
    setCurrentPage(0);
    setSkip(0);
  };

  const handleSortChange = (e) => {
    const value = e.target.value;
    setSortBy(value);
    setSkip(0);
    setCurrentPage(0);
  };

  const handleDateSelection = (date) => {
    console.log("Selected Date:", date);
  };

  const handleAddNewClick = () => {
    navigate("/contracts_popup");
  };

  const closePopup = () => {
    setEditData(null);
    setIsPopupOpen(false);
  };


  const isAllSelected = selectedRows.length === tableData.length;
  const isAnySelected = selectedRows.length > 0;

  const handleSelectAll = () => {
    setSelectedRows(isAllSelected ? [] : tableData.map((row) => row.id));
  };

  const handleRowSelect = (id) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  const handleDeleteClick = (id) => {
    setDeleteId(id);
    setShowConfirm(true);
  };

  const handleDelete = async () => {
    try {
      const response = await axiosInstance.delete(`/contract/delete/${deleteId}`);

      if (response.status === 200) {
        toast.success("Contract deleted successfully!");
        setTableData((prevData) => prevData.filter((row) => row.id !== deleteId));
        setSelectedRows((prev) => prev.filter((rowId) => rowId !== deleteId));
        setTotal((prevTotal) => prevTotal - 1);
        await fetchContracts()
      } else {
        toast.error("Failed to delete the row!");
      }
    } catch (error) {
      console.error("Delete Error:", error);
      setError(error.message);
      toast.error("Failed to delete the contract: " + error.message);
    } finally {
      setShowConfirm(false);
      setDeleteId(null);
    }
  };

  const handleConvertToJob = async (contractId) => {
    const contract = contractData.find(c => c.id === contractId);

    if (!contract) {
      toast.error("Contract not found.");
      return;
    }

    if (contract.job_converted === "1") {
      setSelectedContractId(contractId);
      setConfirmConvertOpen(true);
      return;
    }

    await convertContract(contractId);
  };

  const convertContract = async (contractId) => {
    try {

      const response = await axiosInstance.get(
        `/contract_trigger/contract_manual_data/${contractId}`,
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.status === 200) {
        setManualTriggerData(response.data.data || []);
        setSelectedContractId(contractId);
        setManualTriggerOpen(true);

      } else {
        toast.error("Failed to load job types.");
      }

    } catch (error) {

      console.error("Error during conversion:", error);
      toast.error("Something went wrong.");

    }
  };

  const confirmConvert = async () => {
    if (selectedContractId) {
      await convertContract(selectedContractId);
    }
    setConfirmConvertOpen(false);
  };

  const cancelConvert = () => {
    setConfirmConvertOpen(false);
    setSelectedContractId(null);
  };


  const handleRowClick = async (contract_id) => {
    if (!permission || permission.view_permission !== "1") {
      return;
    }

    try {
      const selectedContract = contractData.find(c => c.id === contract_id);
      const response = await axiosInstance.get(`/contract/edit/${contract_id}`);

      if (response.data && response.data.charges) {
        navigate("/contractviewpage", {
          state: {
            charges: response.data.charges,
            total_sales_amount: selectedContract?.total_sales_amount || 0,
            total_cost_amount: selectedContract?.total_cost_amount || 0,
          }
        });
      } else {
        throw new Error("Contract data not found");
      }
    } catch (error) {
      setError(error.message);
      console.error("Error fetching Contract details:", error);
    }
  };

  const handleSearch = async (term) => {
    setSearchTerm(term);
    setSkip(0);
    await fetchContracts(term);
  };

  const handleApplyFilters = (appliedFilters) => {
    setFilters(appliedFilters);
    setSkip(0);
    setCurrentPage(0);
    fetchContracts(searchTerm, appliedFilters);
  };

  const handleResetFilters = () => {
    const emptyFilters = {
      contractCode: [],
      project: [],
      plantCode: [],
      fromDate: null,
      toDate: null,
      profitCenter: [],
      city: [],
      state: [],
      zone: []
    };

    setFilters(emptyFilters);
    fetchContracts(searchTerm, emptyFilters);
  };

  return (
    <>
      <Contracts_header onSearch={handleSearch} />
      <div className="container">
        <div className="header" style={{ marginBottom: '5px' }}>
          <div className="left-header">
            <h3>All Contracts ({total})</h3>
          </div>
          <div className="right-header">
            <PermissionWrapper permissionKey="create_permission">
              {!isAnySelected && (
                <button id="addNewBtn" onClick={handleAddNewClick}>
                  Add New
                </button>
              )}
            </PermissionWrapper>

            <div
              className={`project-popup-filter-setshow-image ${showFilter ? "active" : ""}`}
              onClick={() => setShowFilter(!showFilter)}
            >
              <img
                src={filterOpenCloseIcon}
                alt="Filter"
                className="project-popup-filter-icon"
                title={showFilter ? "Hide Filters" : "Show Filters"}
              />
            </div>

          </div>
        </div>

        <div className={`filteropenclose-wrapper ${showFilter ? "open" : ""}`}>
          <ContractFilter
            onApply={handleApplyFilters}
            onReset={handleResetFilters}
          />
        </div>

        <div style={{ overflowX: 'auto', whiteSpace: 'nowrap', scrollbarWidth: 'none', OverflowStyle: 'none', WebkitOverflowScrolling: 'touch', scrollBehavior: 'smooth' }}>
          <table>
            <thead>
              <tr>
                {/* <th style={{ width: "1px" }}>
                <input type="checkbox" />
              </th> */}
              <th
                style={{
                  width: "60px",
                  minWidth: "60px",
                  textAlign: "center",
                  padding: "4px"
                }}
              >
                S.No
              </th>
              <th>Contract code</th>
              <th>Project</th>
              <th>Sales Amount</th>
              <th>Cost Amount</th>
              <th>Date</th>
              <th>Actions</th>
              <th></th>

              </tr>
            </thead>
            <tbody>
              {contractData.length > 0 ? (
                contractData.map((contract, index) => (
                  <tr key={index}>
                    {/* <td>
                  <input
                    type="checkbox"
                    checked={selectedRows.includes(index)}
                    onChange={() => handleRowSelect(index)}
                  />
                </td> */}
                  <td
                    style={{
                      width: "60px",
                      minWidth: "60px",
                      textAlign: "center",
                      padding: "4px"
                    }}
                  >
                    {skip + index + 1}
                  </td>
                  <td style={{ cursor: 'pointer' }} onClick={() => handleRowClick(contract.id)}>{contract.contract_code}</td>
                  <td style={{ cursor: 'pointer' }} onClick={() => handleRowClick(contract.id)}>{contract.project_name}</td>
                  <td style={{ cursor: 'pointer' }} onClick={() => handleRowClick(contract.id)}>{contract.total_sales_amount}</td>
                  <td style={{ cursor: 'pointer' }} onClick={() => handleRowClick(contract.id)}>{contract.total_cost_amount}</td>
                  <td style={{ cursor: 'pointer' }} onClick={() => handleRowClick(contract.id)}>{contract.modifieddate}</td>

                    <td>
                      <AdditionalPermissionWrapper permissionKey="convert_to_jobs">
                        {(() => {
                          const today = new Date().toISOString().split("T")[0];
                          const start = contract.contract_start_date;
                          const end = contract.contract_expiry_date;

                          let disabled = false;
                          let tooltip = "";

                          if (today < start) {
                            disabled = true;
                            tooltip = "Contract not started yet";
                          } else if (today > end) {
                            disabled = true;
                            tooltip = "Contract expired";
                          }

                          return (
                            <div style={{ position: "relative", display: "inline-block" }}>
                              <button
                                className="contract-convert-button"
                                onClick={() => handleConvertToJob(contract.id)}
                                disabled={disabled}
                                style={{
                                  width: 'auto',
                                  height: '28px',
                                  border: '1px solid #12B76A',
                                  color: disabled ? '#ccc' : '#12B76A',
                                  backgroundColor: 'transparent',
                                  borderRadius: '6px',
                                  fontFamily: "'Work Sans', sans-serif",
                                  fontSize: '12px',
                                  fontWeight: 500,
                                  cursor: disabled ? 'not-allowed' : 'pointer',
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  transition: 'all 0.2s ease'
                                }}
                              >
                                {"Convert To Job"}
                              </button>

                              {disabled && tooltip && (
                                <div
                                  className="hover-tooltip"
                                  style={{
                                    position: "absolute",
                                    top: "110%",
                                    left: "50%",
                                    transform: "translateX(-50%)",
                                    backgroundColor: "#333",
                                    color: "#fff",
                                    padding: "6px 10px",
                                    fontSize: "11px",
                                    borderRadius: "4px",
                                    whiteSpace: "nowrap",
                                    zIndex: 10,
                                    opacity: 0,
                                    pointerEvents: "none",
                                    transition: "opacity 0.2s ease"
                                  }}
                                >
                                  {tooltip}
                                </div>
                              )}
                            </div>
                          );
                        })()}
                      </AdditionalPermissionWrapper>
                    </td>


                    <td>
                      <div className="actions">

                        <PermissionWrapper permissionKey="edit_permission">
                          <span
                            className="edit-icon"
                            style={{ cursor: 'pointer' }}
                          >
                            <img src={Vector} alt="Edit Icon" width="20" height="20" onClick={() => handleEditClick(contract.id)} />
                          </span>
                        </PermissionWrapper>


                        <>
                          <PermissionWrapper permissionKey="delete_permission">
                            <span className="delete-icon">
                              <img
                                src={Delete}
                                alt="Delete Icon"
                                width="40"
                                height="40"
                                style={{ cursor: "pointer" }}
                                onClick={() => handleDeleteClick(contract.id)}
                              />
                            </span>
                          </PermissionWrapper>
                        </>

                      </div>
                    </td>

                  </tr>
                ))) : (
                <tr>
                  
                    <td colSpan="7" style={{ textAlign: 'center', padding: '20px', fontSize: '14px', color: '#666' }}>
                    {searchTerm || filters.contractCode?.length || filters.project?.length
                      ? `No contract found matching your criteria`
                      : `No contracts available`}
                    </td>
             
                </tr>
              )}
            </tbody>

          </table>
        </div>

        <CommonPagination
          currentPage={currentPage}
          totalPages={totalPages}
          limit={limit}
          onPageChange={handlePageClick}
          onLimitChange={handleLimitChange}
        />
      </div>
      <CommonFooter />
      <ContractManualTriggerPopup
        key={selectedContractId}
        isOpen={manualTriggerOpen}
        data={manualTriggerData}
        contractId={selectedContractId}
        onClose={() => {
          setManualTriggerOpen(false);
          fetchContracts(); 
        }}
      />
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
      <ConfirmDialog
        open={showConfirm}
        title="Delete Contract"
        message="Are you sure you want to delete this contract?"
        confirmText="Delete"
        cancelText="Cancel"
        onConfirm={handleDelete}
        onCancel={() => setShowConfirm(false)}
      />
      <ConfirmDialog
        open={confirmConvertOpen}
        title="Convert Contract"
        message="This contract is already converted to a Job. Do you want to convert it again?"
        confirmText="Yes, Convert Again"
        cancelText="No"
        onConfirm={confirmConvert}
        onCancel={cancelConvert}
      />
    </>
  )
}

export default Contracts